import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// import { postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import { handleBackdropConfig, handleSnackBar } from './global'
import MESSAGES from '../constants/messages'
import bookingService from '../services/booking.service'

export const createBooking = createAsyncThunk(
  'booking/create',
  async ({ data, onSucess }: { data: any; onSucess: any }, { dispatch }) => {
    try {
      dispatch(setCreatingBooking(true))
      dispatch(handleBackdropConfig({ open: true }))

      const resp: any = await bookingService.create({ body: data }) //postAPICall(nextAPIRoutes.CREATE_BOOKING, data)

      dispatch(handleBackdropConfig({ open: false }))
      onSucess()
      dispatch(setCreatingBooking(false))
      return resp.data.data ?? []
    } catch (e: any) {
      dispatch(setCreatingBooking(false))
      dispatch(handleBackdropConfig({ open: false }))

      dispatch(
        handleSnackBar({
          open: true,
          severity: 'error',
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        }),
      )
      return []
    }
  },
)

export const updateBookingStatus = createAsyncThunk(
  'booking/statusChange',
  async ({ data, onSucess }: { data: any; onSucess: any }, { dispatch }) => {
    try {
      dispatch(handleBackdropConfig({ open: true }))

      const resp: any = await bookingService.updateStatus({ body: data })
      //  postAPICall(
      //   nextAPIRoutes.UPDATE_BOOKING_STATUS,
      //   data,
      // )

      dispatch(handleBackdropConfig({ open: false }))
      onSucess()
      return resp.data.data ?? []
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: 'error',
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        }),
      )
      return []
    }
  },
)

export const completeBookingPayment = createAsyncThunk(
  'booking/bookingComplete',
  async ({ data, onSucess }: { data: any; onSucess: any }, { dispatch }) => {
    try {
      dispatch(handleBackdropConfig({ open: true }))

      const resp: any = await bookingService.completePayment({ body: data })
      // postAPICall(
      //   nextAPIRoutes.COMPLETE_BOOKING_PAYMENT,
      //   data,
      // )

      dispatch(handleBackdropConfig({ open: false }))
      onSucess()
      return resp.data.data ?? []
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: 'error',
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        }),
      )
      return []
    }
  },
)

export const uploadBookingDocs = createAsyncThunk(
  'booking/create',
  async (
    {
      data,
      onSucess,
    }: {
      data: {
        booking_stage: number
        documents: Array<any>
        id: number | string
      }
      onSucess: any
    },
    { dispatch },
  ) => {
    try {
      dispatch(setSavingBookingDocs(true))

      const resp: any = await bookingService.uploadDocuments({ body: data })
      // postAPICall(
      //   nextAPIRoutes.UPLOAD_BOOKING_DOCS,
      //   data,
      // )

      dispatch(setSavingBookingDocs(false))
      onSucess()
      return resp.data.data ?? []
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: 'error',
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        }),
      )
      return []
    }
  },
)

export const suggestDateChanges = createAsyncThunk(
  'booking/suggestDateChanges',
  async ({ data, onSucess }: { data: any; onSucess: any }, { dispatch }) => {
    try {
      const resp: any = await bookingService.suggestDates({
        body: data,
      })
      // postAPICall(
      //   nextAPIRoutes.SUGGEST_DATE_CHANGES,
      //   data,
      // )

      onSucess()
      return resp.data.data ?? []
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: 'error',
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        }),
      )
      return []
    }
  },
)
export const saveDateChanges = createAsyncThunk(
  'booking/saveDateChanges',
  async ({ data, onSucess }: { data: any; onSucess: any }, { dispatch }) => {
    try {
      const resp: any = await bookingService.saveSuggestDates({ body: data }) //postAPICall(nextAPIRoutes.SAVE_DATE_CHANGES, data)

      onSucess()
      return resp.data.data ?? []
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: 'error',
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        }),
      )
      return []
    }
  },
)

const bookingSlice = createSlice({
  name: 'booking',
  initialState: {
    creatingBooking: false,
    savingBookingDocs: false,
  },
  reducers: {
    setCreatingBooking: (state, { payload }) => {
      state.creatingBooking = payload
    },
    setSavingBookingDocs: (state, { payload }) => {
      state.savingBookingDocs = payload
    },
  },
})

export default bookingSlice.reducer
export const { setCreatingBooking, setSavingBookingDocs } = bookingSlice.actions
